import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { ProlinkService }           from './prolink.service';
import { ProlinkSettingsComponent } from './prolink.settings.component';
import { ProlinkStates }            from './prolink.states';
import { SharedModule }             from '../shared/shared.module';
import { VendorsModule }            from '../vendors/vendors.module';

@NgModule({
  declarations: [
    ProlinkSettingsComponent
  ],
  entryComponents: [
    ProlinkSettingsComponent
  ],
  imports: [
    SharedModule,
    VendorsModule,

    UIRouterUpgradeModule.forChild({ states: ProlinkStates })
  ],
  providers: [
    ProlinkService
  ]
})
export class ProlinkModule {}
